import {createEvent} from '../../api/events'

export default store => event => {
  const {token} = store.getState()

  store.setState({
    isHydratingEvents: true,
  })

  if (!token) return

  return createEvent({
    token,
    event,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(newEvent => {
      store.setState({
        isHydratingEvents: false,
      })
    })
    .catch(error => {
      store.setState({
        isHydratingEvents: false,
      })
    })
}
